import {
  type LinkProps,
  type NavLinkProps,
  Link as RRLink,
  type NavigateOptions as RRNavigateOptions,
  NavLink as RRNavLink,
  useNavigate as RRUseNavigate,
  type To,
} from 'react-router-dom-original'

import { useTenantHref } from './modules/shared/hooks/useTenantHref'

/**
 * Wrapped Link component that logs usage and applies tenant-specific URL wrapping
 */
export const Link: React.FC<LinkProps> = (props) => {
  const wrap = useTenantHref()

  return <RRLink {...props} to={wrap(props.to)} />
}

/**
 * Wrapped NavLink component that logs usage and applies tenant-specific URL wrapping
 */
export const NavLink: React.FC<NavLinkProps> = (props) => {
  const wrap = useTenantHref()

  return <RRNavLink {...props} to={wrap(props.to)} />
}

/**
 * Wrapped useNavigate hook that logs usage and applies tenant-specific URL wrapping
 */
export const useNavigate = (): NavigateFunction => {
  const wrap = useTenantHref()
  const navigate = RRUseNavigate()

  return (to: To | number, options?: NavigateOptions) => {
    // pass numbers or objects without pathname untouched
    if (typeof to === 'number') return navigate(to)

    return navigate(options?.tenant === false ? to : wrap(to), options)
  }
}

export interface NavigateFunction {
  (to: To, options?: NavigateOptions): void | Promise<void>
  (delta: number): void | Promise<void>
}

export interface NavigateOptions extends RRNavigateOptions {
  /** Navigate to a path without tenant prefix */
  tenant?: false
}

// Re-export all components from the original react-router-dom-original
export * from 'react-router-dom-original'
